import React, { useState } from "react";
import { useEffect } from "react";
import "../InvoiceModal.css";
import StatusIcons from "../../../../../../../../../Components/StatusIcons/StatusIcons";
import { convertTime } from "../../../../../../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const ShipmentDetails = ({ data, Role, type = "not Print" }) => {
  const { t } = useTranslation("finances");
  const [totalFulfilment, settotalFulfilment] = useState(0);
  const [totalWeight, settotalWeight] = useState(0);
  const [totalItems, settotalItems] = useState(0);

  const formatValue = (value) => {
    return typeof value === "number" ? value.toFixed(2) : t("slip.notAvailable");
  };
  function sumItemQuantities(orderDetails) {
    return orderDetails.reduce(
      (total, current) => total + Number(current.item_quantity),
      0,
    );
  }
  function sumTotalWeight(orderDetails) {
    return orderDetails.reduce((total, current) => {
      const weight = Number(current.weight);
      const quantity = Number(current.item_quantity);
      return total + weight * quantity;
    }, 0);
  }
  const calculateTotalCost = (data) => {
    let totalCost = 0;
    let total = 0;
    if (data?.additional_costs?.length > 0) {
      data.additional_costs.forEach((currentItem) => {
        const cost = parseFloat(currentItem.cost ?? 0);
        totalCost += cost;
      });
    }
    total = totalCost + parseFloat(data.fulfillment_cost ?? 0);
    return parseFloat(total).toFixed(2);
  };

  useEffect(() => {
    if (data) {
      let items = 0;
      let weight = 0;
      let cost = 0;
      data.forEach((element) => {
        const singleCost = parseFloat(calculateTotalCost(element) ?? 0);
        items = sumItemQuantities(element?.order_details) + items;
        weight = sumTotalWeight(element?.order_details) + weight;
        cost += singleCost;
      });
      settotalFulfilment(cost);
      settotalWeight(weight);
      settotalItems(items);
    }
  }, [data]);

  let th_style =
    type === "Print"
      ? "invmodal__shdetails_tablehd_print"
      : "invmodal__shdetails_tablehd";
  let td_style =
    type === "Print"
      ? "ltlinvmodal__shdetails_tableitem_print"
      : "ltlinvmodal__shdetails_tableitem";

  return (
    <>
      <div className="invmodal__shipment_details">
        <div className="invmodal__shipment_detailshding">{t("slip.orderDetails")}</div>
        <table className="invmodal__shdetails_table">
          <thead>
            <th className={th_style}>#</th>
            <th className={th_style}>{t("slip.orderId")}</th>
            <th className={th_style}>{t("slip.orderType")}</th>
            <th className={th_style}>{t("slip.orderStatus")}</th>
            <th className={th_style}>{t("slip.customerName")}</th>
            <th className={th_style}>{t("slip.fulfilmentStatus")}</th>
            <th className={th_style}>{t("slip.fulfilmentCost")}</th>
            <th className={th_style}>
              {t(`slip.roles.${Role}`, { defaultValue: Role })}
            </th>
            <th className={th_style}>{t("slip.orderItems")}</th>
            <th className={th_style}>{t("slip.orderWeight")}</th>
            <th className={th_style}>{t("slip.fulfilmentBillingStatus")}</th>
            <th className={th_style}>{t("slip.createdAt")}</th>
          </thead>
          <tbody>
            {" "}
            {data?.map((item, index) => (
              <tr key={index}>
                {" "}
                <td className={td_style}>{index + 1}</td>
                <td className={td_style}>{item?.order_id ?? "-"}</td>
                <td className={td_style}>{item?.type ?? "-"}</td>
                <td className={td_style}>
                  <StatusIcons
                    status={item?.status}
                    noDot={true}
                    noBg={type === "Print"}
                    noBorder={type === "Print"}
                    isPrint={type === "Print"}
                  />
                </td>
                <td className={td_style}>
                  {item?.order_shipping_address_details?.first_name ?? "-"}
                </td>
                <td className={td_style}>
                  <StatusIcons
                    status={item?.fullfilment_status?.name}
                    isPrint={type === "Print"}
                    noDot={type === "Print"}
                    noBg={type === "Print"}
                  />
                </td>
                <td className={td_style}>{calculateTotalCost(item) ?? "0"}$</td>
                <td className={td_style}>
                  {Role === "Warehouse"
                    ? (item?.warehouse?.name ?? "-")
                    : (item?.user?.username ?? "-")}
                </td>
                <td className={td_style}>
                  {item?.order_details
                    ? sumItemQuantities(item.order_details)
                    : 0}
                </td>
                <td className={td_style}>
                  {item?.order_details ? sumTotalWeight(item.order_details) : 0}
                </td>
                <td className={td_style}>
                  <StatusIcons
                    status={item?.fulfillment_billing_status}
                    isPrint={type === "Print"}
                    noDot={type === "Print"}
                    noBg
                    noBorder
                  />
                </td>
                <td className={td_style}>{convertTime(item?.created_at)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td className={td_style}>
                <b>{data?.length ?? 0}</b>
              </td>
              <td className={td_style}></td>
              <td className={td_style}></td>
              <td className={td_style}></td>
              <td className={td_style}></td>
              <td className={td_style}></td>
              <td className={td_style}>
                <b>{totalFulfilment}$</b>
              </td>
              <td className={td_style} colSpan="1"></td>
              <td className={td_style}>
                <b>{totalItems}</b>
              </td>
              <td className={td_style}>
                <b>{totalWeight}</b>
              </td>
              <td className={td_style}></td>
              <td className={td_style}></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default ShipmentDetails;
